const listNamesConfig = {
  entityItemsNamePlural: "Player Subscriptions",
  entityItemName: "Player Subscription",
  areaAccessName: "Playlists"
  // TODO: to change later to PlayerSubscriptions when areaAccessName is handled well in BSPortal.
};

export default listNamesConfig;